import PropTypes from 'prop-types';
import { renderPortal } from '@adsk/alloy-react-helpers';
/**
 * A Portal component.  Provides a wrapper of ReactDOM.createPortal
 */
const Portal = _ref => {
  let {
    children,
    container
  } = _ref;
  return renderPortal(children, container);
};
Portal.displayName = 'Portal';
Portal.propTypes = {
  /** portal container, when container empty children rendered within current node */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /** portal content */
  children: PropTypes.any
};
export default Portal;
//# sourceMappingURL=Portal.js.map